import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState, useEffect, useRef } from 'react';
import styles from './EmailInput.module.css';
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EmailInput = forwardRef(({ value, onChange, error, placeholder = 'Enter your email', required = false, disabled = false, className = '', onBlur, ...props }, ref) => {
    const [isValid, setIsValid] = useState(false);
    const [hasInteracted, setHasInteracted] = useState(false);
    const validationTimerRef = useRef(null);
    // Validate email with debounce
    useEffect(() => {
        if (!hasInteracted || !value) {
            return;
        }
        // Clear existing timer
        if (validationTimerRef.current) {
            clearTimeout(validationTimerRef.current);
        }
        // Set new timer
        validationTimerRef.current = setTimeout(() => {
            if (value && EMAIL_REGEX.test(value)) {
                setIsValid(true);
            }
            else {
                setIsValid(false);
            }
        }, 500);
        // Cleanup on unmount or dependency change
        return () => {
            if (validationTimerRef.current) {
                clearTimeout(validationTimerRef.current);
            }
        };
    }, [value, hasInteracted]);
    const handleChange = (e) => {
        onChange(e.target.value);
        setHasInteracted(true);
    };
    const handleBlur = (e) => {
        setHasInteracted(true);
        onBlur?.(e);
    };
    const showError = hasInteracted && value && !isValid;
    const showSuccess = hasInteracted && value && isValid;
    return (_jsxs("div", { className: `${styles.wrapper} ${className}`, children: [_jsxs("div", { className: styles.inputWrapper, children: [_jsx("input", { ...props, ref: ref, type: "email", value: value, onChange: handleChange, onBlur: handleBlur, className: `${styles.input} ${!!error || showError ? styles.error : ''}`, placeholder: placeholder, required: required, disabled: disabled, "aria-invalid": !!(error || showError), "aria-describedby": error ? 'email-error' : undefined, autoComplete: "email" }), showSuccess && (_jsx("svg", { className: styles.successIcon, viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true", children: _jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }))] }), error && (_jsx("span", { className: styles.errorMessage, role: "alert", id: "email-error", children: error })), showError && !error && (_jsx("span", { className: styles.errorMessage, role: "alert", children: "Please enter a valid email address" }))] }));
});
EmailInput.displayName = 'EmailInput';
